/* model existiert doppelt!! zusammenführen */
export class TransportOption {

  id: number;
  externalKey: string;
  nameDictionaryKey: string;
  hintDriverDictionaryKey: string;
  allwaysShowHint: boolean;
  optional: boolean;
  transportOptions = new Array<TransportOption>();
  minimumSelectedOptions: number;
  columnIndex: number;
  rowIndex: number;
  onlyInternal: boolean;
  color: string;
  messagingReference: string;
  amountOfPallettesMandatory: boolean;
  amountOfBoxesMandatory: boolean;
  amountInKilogrammMandatory: boolean;
  amountInLiterMandatory: boolean;
  amountOthersMandatory: boolean;
  amountMandatoryInTerminal: boolean;
  amountMandatoryInTime: boolean;

  hasParameter: boolean;
  parameterNameDictionaryKey: string;
  readOnlyAtTerminal: boolean;

  parameterValues = new Array<TransportOptionParameterValue>();

  resources = new Array<string>();

  constructor(option?: any) {
    if (option != null) {
      this.id = option.id;
      this.externalKey = option.externalKey;
      this.nameDictionaryKey = option.nameDictionaryKey;
      this.hintDriverDictionaryKey = option.hintDriverDictionaryKey;
      this.optional = option.optional;
      this.minimumSelectedOptions = option.minimumSelectedOptions;
      this.columnIndex = option.columnIndex;
      this.rowIndex = option.rowIndex;
      this.onlyInternal = option.onlyInternal;
      this.color = option.color;
      this.messagingReference = option.messagingReference;
      this.amountOfPallettesMandatory = option.amountOfPallettesMandatory;
      this.amountOfBoxesMandatory = option.amountOfBoxesMandatory;
      this.amountInKilogrammMandatory = option.amountInKilogrammMandatory;
      this.amountInLiterMandatory = option.amountInLiterMandatory;
      this.amountOthersMandatory = option.amountOthersMandatory;
      this.amountMandatoryInTerminal = option.amountMandatoryInTerminal;
      this.amountMandatoryInTime = option.amountMandatoryInTime;
      this.allwaysShowHint = option.allwaysShowHint;
      this.readOnlyAtTerminal = option.readOnlyAtTerminal;

      if (option.resources != null) {
        for (const resource of option.resources) {
          this.resources.push(resource);
        }
      }
      if (option.transportOptions != null) {
        for (const to of option.transportOptions) {
          this.transportOptions.push(new TransportOption(to));
        }
      }

      this.hasParameter = option.hasParameter;
      this.parameterNameDictionaryKey = option.parameterNameDictionaryKey;

      if (option.values != null) {
        for (const value of option.values) {
          this.parameterValues.push(new TransportOptionParameterValue(value));
        }
      }

    }
  }
}

export class TransportOptionParameterValue {

  id: number;
  valueDictionaryKey: string;

  constructor(value?: any) {
    if (value != null) {
      this.id = value.id;
      this.valueDictionaryKey = value.valueDictionaryKey;
    }
  }

}
